import { Injectable, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

@Injectable()
export class AuthService {
  public isLoggedIn: boolean = false;
  public isLocated: boolean = false;
  public isConfirm: boolean = false;
  public redirectLink: string = '/';

  public token: string;

  changeLoginSubject = new BehaviorSubject(null);

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor() {
    this.token = localStorage.getItem('horseapp_token');
    this.isLoggedIn = localStorage.getItem('horseapp_token') !== null ? true : false;
    this.isLocated = localStorage.getItem('isLocated') !== null ? true : false;
    this.isConfirm = true;//localStorage.getItem('isConfirm') !== null ? true : false;
  }

  login(token: string): void {
    localStorage.setItem('horseapp_token', token);
    this.isLoggedIn = true;
    this.token = token;
    this.sendEvent();
  }

  logout(): void {
    this.token = null;
    localStorage.removeItem('horseapp_token');
    this.isLoggedIn = false;
    this.sendEvent();
  }

  sendEvent(){
    this.changeLoginSubject.next(this.isLoggedIn);
  }

  getRedirectLink():string{
    let link = this.redirectLink;
    this.redirectLink = '/';
    return link;
  }

  getToken(){
    return this.token;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/auth.service.ts